import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { PanelMemberService } from 'src/app/shared/panel-member.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { PanelMember } from 'src/app/model/panel-member.model';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-panel-member',
  templateUrl: './panel-member.component.html',
  styleUrls: ['./panel-member.component.scss']
})
export class PanelMemberComponent implements OnInit {

  fetchPanelMembers = new EventEmitter();
  constructor(public service: PanelMemberService, private notificationService: NotificationService, public dialogRef: MatDialogRef<PanelMemberComponent>) { }

  ngOnInit() {
  }
  onSubmit() {
    if (this.service.form.valid) {
      let panelMemberId = this.service.form.value.id;
      let fullName = this.service.form.value.fullName;
      let email = this.service.form.value.email;
      let mobile = this.service.form.value.mobile;
      let panelMember = new PanelMember(panelMemberId, fullName, mobile, email);

      if (!this.service.form.value.id) {
        this.service.createPanelMember([panelMember]).then(
          res => {
            this.notificationService.success(res && res.data && res.data.message);
            this.fetchPanelMembers.emit(true);
            this.onClose();
          },
          err => {
            if (err && err.data && err.data.listOfRejectedPanelMembers) {
              err.data.listOfRejectedPanelMembers.forEach(rejectedPanelMember => {
                rejectedPanelMember.listOfErrorMessageAssociated.forEach(errorMessage => {
                  this.notificationService.warn(errorMessage);
                });
              });
            }
            return false;
          }
        );
      } else {
        this.service.updatePanelMember(panelMember, this.service.form.value.id)
          .then(data => {
            this.notificationService.success(data);
            this.fetchPanelMembers.emit(true);
            this.onClose();
          }).catch(err => {
            try {
              const { errors } = err;
              errors.forEach(error => {
                const { message } = error;
                this.notificationService.warn(message);
              });
            } catch (error) {
              const errMessage = typeof err === 'string' ? err : 'Failed to update';
              this.notificationService.warn(errMessage);
            }
          });
      }
    }
  }
  onClose() {
    this.service.form.reset();
    this.dialogRef.close();
  }
  onClear() {
    this.service.form.reset();
    this.notificationService.success('Cleared');
  }
}
